<template>
  <div v-if="user">
        <div class="row">
            <div class="col-sm">
                <BaseCard :title="$t('profile.basic_data')">
                    <UserPersonalDataForm :user="user"/>
                </BaseCard>
            </div>
            <div class="col-sm">
                <BaseCard :title="$t('profile.password_change')">
                    <UserChangePasswordForm :user="user"/>
                </BaseCard>
            </div>
        </div>
        <div class="row">
            <div class="col-sm">
                <BaseCard :title="$t('profile.user_photo')">
                    <UserPhoto :user="user"/>
                </BaseCard>
            </div>
        </div>
  </div>
</template>

<script>
    import UserPersonalDataForm from "../../components/User/UserPersonalDataForm";
    import UserChangePasswordForm from "../../components/User/UserChangePasswordForm";
    import {mapGetters} from "vuex";
    import UserPhoto from "../../components/User/UserPhoto";

    export default {
        name: "PersonalData",
        components: {UserPersonalDataForm, UserChangePasswordForm, UserPhoto},

        computed: {
            ...mapGetters('Auth', ['user'])
        }
    }
</script>

<style scoped>

</style>